/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const modelFilterOverviewNodes = Array.from(document.querySelectorAll('.model-filter-overview'));
if (modelFilterOverviewNodes.length) {
    import(/* webpackChunkName: "ModelFilterOverview" */ './components/ModelFilterOverview').then(({ default: ModelFilterOverview }) => {
        modelFilterOverviewNodes.forEach((node) => render(<ModelFilterOverview {...parseDataToProps(node.dataset)}/>, node));
    });
}
